export default __webpack_public_path__ + "static/media/2_of_clubs.d5d968ca.png";